import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	assignee: {
		id: 'search-page.jira-assignee.assignee',
		defaultMessage: 'Assignee: {assigneeName}',
		description: 'Label for the assignee of a Jira work item',
	},
	unassigned: {
		id: 'search-page.jira-assignee.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Label for the unassigned work items',
	},
});
